import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import ShippingAccountActionableFilterPill from '../../../../../components/actionable-filter-pill/connected/shipping/shipping-account';
import messages from './messages';
import { SHIPPING_ACCOUNT } from '../../../../../filters/constants';

export default {
  id: SHIPPING_ACCOUNT,
  displayName: <FormattedMessage {...messages.shippingAccount} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'ShippingAccount',
  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },
  shouldHideActionButtons: true,
  expectsArgumentAsArray: true,
  allowsMultipleSelection: true,
  actionableFilterPill: ShippingAccountActionableFilterPill,
};
